import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useIntl } from 'react-intl';
import PropTypes, { object, bool, arrayOf, string, func, shape } from "prop-types";
import {
  Link,
} from '@material-ui/core';
import {
  fetchCategoryApisAccess,
  fetchOrganizationsFiltered,
} from '../../../../actions/templateCategory';
import {
  getCategoryApisAccess,
  getIsCategoryApisAccessError,
  getOrganizationsListResult,
  getValidationErrors,
} from '../../../../reducers/templateCategory';
import styles from './styles';
import {
  FilterByOrganization,
  FilterByState,
  FilterByApplicable,
  FilterByCompliance,
  FilterByAssigned,
} from './controls';
import ListContainer from '../../../list';
import { getStatusColor, getComplianceLabel, getStatusLabel } from '../../../Api/List/utils';
import { PolicyComplianceHeader, getComplianceIcon } from '../../../Api/List';
import { getI18n } from "../../../../utils/intl";
import {
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
} from '../../../../constants';
import { get, map, lowerCase, upperFirst } from 'lodash';
import { FilterByText } from '../../../../pageComponents';

export const TCApis = (props) => {
  const {
    categoryUuid,
    categoryApis,
    organizationsListResult,
    fetchOrganizationsFiltered,
    classes,
    currentTab,
    fetchCategoryApisAccess,
    isLoading = false,
    pageErrors,
    isError,
  } = props;

  const [currentRows, setCurrentRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);

  const [filterByName, setFilterByName] = useState('');
  const [apiNameFilter, setApiNameFilter] = useState('');

  const [filterByOrganization, setFilterByOrganization] = useState();
  const [orgSearchText, setOrgSearchText] = useState('');
  const [orgOptions, setOrgOptions] = useState([]);

  const [stateFilterValue, setStateFilterValue] = useState('All');
  const [applicableFilterValue, setApplicableFilterValue] = useState('All');
  const [complianceFilterValue, setComplianceFilterValue] = useState('All');
  const [assignedFilterValue, setAssignedFilterValue] = useState('All');

  const [errors, setErrors] = useState([]);

  const { getI18nMessage } = getI18n(useIntl());

  const formatApiStatus = (status) => {
    const statusIconStyle = {
      fill: getStatusColor(status),
    };
    return (
      <span className={classes.apiStatusField}>
        <FiberManualRecordIcon style={statusIconStyle} className={classes.statusIcon} />
        <span>{upperFirst(lowerCase(getStatusLabel(status)))}</span>
      </span>);
  }

  const totalElements = get(categoryApis, 'totalElements', 0);
  const totalPages = get(categoryApis, 'totalPages', 0);

  const getListColumns = (getI18nMessage, classes) => [{
    id: 'apiName',
    label: getI18nMessage('label.category.details.apis.columns.apiname'),
    minWidth: 200,
    format: ({ apiName: apiName, apiUuid: apiUuid } = {}) => (<Link underline="none" href={`/publish/apis/details/${apiUuid}`}>
      {apiName}
    </Link>),
    value: ({ apiName, apiUuid } = {}) =>
      ({ apiName, apiUuid }),
  },
  {
    id: 'managingOrganization',
    label: getI18nMessage('label.category.details.apis.columns.managingorganization'),
    value: (item) => item.apiManagingOrgName,
  },
  {
    id: 'state',
    label: getI18nMessage('label.category.details.apis.columns.apistatus'),
    value: (item) => formatApiStatus(item.portalStatus),
  },
  {
    id: 'applicability',
    label: getI18nMessage('label.category.details.apis.columns.applicable'),
    value: (item) => (<span className={classes.tickMark}>{item.categoryApplicability === 'APPLICABLE' ? '✓' : ''}</span>),
  },
  {
    id: 'accessStatus',
    label: getI18nMessage('label.category.details.apis.columns.accessstatus'),
    value: (item) => (<span className={classes.tickMark}>{item.categoryApiAccessStatus === 'ASSIGNED' ? '✓' : ''}</span>),
  },
  {
    id: 'policyCompliance',
    label: (
      <PolicyComplianceHeader classes={classes} label={getI18nMessage('label.api.list.column.policyCompliance')} />
    ),
    value: (item) => {
      const compliance = getComplianceLabel(item.categoryApiCompliance);
      const complianceIcon = getComplianceIcon(compliance, classes);
      if (item) {
        return (
          <div className={classes.complianceStatus}>
            <div>{complianceIcon}</div>
            <div>{getComplianceLabel(item.categoryApiCompliance)}</div>
          </div>
        );
      }
      return <></>;
    },
  },
  ];

  const selectedOrgOption = find(orgOptions, item => item.uuid === filterByOrganization);

  useEffect(() => {
    const results = get(categoryApis, 'results', []);
    setCurrentRows(results);
  }, [categoryApis]);

  useEffect(() => {
    if (organizationsListResult.length > 0) {
      const orgOptions = map(organizationsListResult, item => ({
        uuid: item.uuid, name: item.name,
      }));
      setOrgOptions(orgOptions);
    }
  }, [organizationsListResult]);

  useEffect(() => {
    setErrors(isError ? pageErrors : []);
  }, [isError, pageErrors]);

  useEffect(() => {
    if (currentTab === 'apis-tab') {
      if (categoryUuid) {
        fetchCategoryApisAccess({
          categoryUuid: categoryUuid,
          filterByName: filterByName,
          filterByApiManagingOrg: filterByOrganization,
          apiManagingOrgUuid: organizationsListResult,
          ...((stateFilterValue !== 'All') && {
            stateFilterValue: stateFilterValue,
          }),
          ...((applicableFilterValue !== 'All') && {
            applicableFilterValue: applicableFilterValue,
          }),
          ...((complianceFilterValue !== 'All') && {
            complianceFilterValue: complianceFilterValue,
          }),
          ...((assignedFilterValue !== 'All') && {
            assignedFilterValue: assignedFilterValue,
          }),
          page: page,
          rowsPerPage: rowsPerPage,
        });

      }
    }
  }, [
    currentTab,
    page,
    rowsPerPage,
    filterByName,
    filterByOrganization,
    stateFilterValue,
    applicableFilterValue,
    complianceFilterValue,
    assignedFilterValue,
    categoryUuid,
  ]);

  useEffect(() => {
    fetchOrganizationsFiltered({ name: '' });
  }, []);

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const applyFilterByName = () => {
    setPage(0);
    setFilterByName(apiNameFilter);
  };

  const onFilterByOrgChange = (event) => {
    if (!event) {
      return;
    }
    const value = get(event, 'target.value', '');
    if (value) {
      fetchOrganizationsFiltered({ name: value });
    }
    // clear on selection by click
    if (get(event, "type", "") === "click") {
      setOrgSearchText('');
    } else {
      setOrgSearchText(value);
    }
  };

  const onFilterByOrganizationChange = (e, value) => {
    if (value) {
      setFilterByOrganization(get(value, 'uuid'));
    } else {
      setFilterByOrganization();
    }
    setPage(0);
    const orgName = get(e, 'target.innerText', '');
    setOrgSearchText(orgName);
    fetchOrganizationsFiltered({ name: orgName });
  };

  const onFilterByStateChange = (value) => {
    setStateFilterValue(value);
    setPage(0);
  };

  const onFilterByApplicableChange = (value) => {
    setApplicableFilterValue(value);
    setPage(0);
  };

  const onFilterByComplianceChange = (value) => {
    setComplianceFilterValue(value);
    setPage(0);
  };

  const onFilterByAssignedChange = (value) => {
    setAssignedFilterValue(value);
    setPage(0);
  };

  return (
    <Fragment>
      <ListContainer
        addButtonLabel={''}
        columns={getListColumns(getI18nMessage, classes) || []}
        hasPaginationDisabled={false}
        hidePagination={false}
        isLoading={isLoading}
        listPageId="apis-list"
        noResultsMessage={getI18nMessage('label.request.list.no.results')}
        notificationStatus={''}
        setNotificationStatus={() => { }}
        notificationMessage={''}
        setNotificationMessage={() => { }}
        pageHeaderTitle={''}
        pageHeaderDescription={''}
        pageHeaderTooltipTitle={getI18nMessage('label.request.list.page.title.help')}
        onAdd={false}
        showListHeader={true}
        disableAdd={true}
        pageClass={classes.pageClass}
        rows={currentRows}
        allowOrdering={false}
        page={page}
        totalElements={totalElements}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        onChangePreviousPage={onChangePreviousPage}
        onChangeNextPage={onChangeNextPage}
        errors={errors}
        filterAndSortContent={(
          <>
            <div className={classes.textFiltersContainer}>
              <FilterByText
                id="tc-apis-filter-by-name"
                fieldContainerClass={classes.textFieldContainer}
                handleChange={setApiNameFilter}
                name={getI18nMessage('label.filter')}
                placeholder={getI18nMessage('label.category.details.apis.filter.apis')}
                value={apiNameFilter}
                handleBlur={applyFilterByName}
              />
              <FilterByOrganization
                filterSelectedOptions={false}
                getOptionLabel={item => (item && item.name) || ''}
                getOptionSelected={(option, value) => {
                  (value ? value.uuid === option.uuid : false)
                }
                }
                hideLabel
                onInputChange={onFilterByOrgChange}
                handleChange={onFilterByOrganizationChange}
                inputLabel={getI18nMessage('label.category.details.apis.filter.apimanagingorg')}
                options={orgOptions}
                searchText={orgSearchText}
                value={selectedOrgOption}
                fieldContainerClass={classes.autoContainer}
              />
              <FilterByState
                fieldContainerClass={classes.textFieldContainer}
                name={getI18nMessage('label.filter')}
                value={stateFilterValue}
                selectFieldClass={classes.selectField}
                handleChange={onFilterByStateChange}
                hideLabel
              />
              <FilterByApplicable
                fieldContainerClass={classes.textFieldContainer}
                name={getI18nMessage('label.filter')}
                value={applicableFilterValue}
                selectFieldClass={classes.selectField}
                handleChange={onFilterByApplicableChange}
                hideLabel
              />
              <FilterByAssigned
                fieldContainerClass={classes.textFieldContainer}
                name={getI18nMessage('label.filter')}
                value={assignedFilterValue}
                selectFieldClass={classes.selectField}
                handleChange={onFilterByAssignedChange}
                hideLabel
              />
              <FilterByCompliance
                fieldContainerClass={classes.textFieldContainer}
                name={getI18nMessage('label.filter')}
                value={complianceFilterValue}
                selectFieldClass={classes.selectField}
                handleChange={onFilterByComplianceChange}
                hideLabel
              />
            </div>
          </>
        )}
      />
    </Fragment>
  );
}


const mapStateToProps = (state) => ({
  categoryApis: getCategoryApisAccess(state),
  organizationsListResult: getOrganizationsListResult(state),
  isError: getIsCategoryApisAccessError(state),
  pageErrors: getValidationErrors(state),
});

const mapDispatchToProps = {
  fetchCategoryApisAccess,
  fetchOrganizationsFiltered,
};

TCApis.propTypes = {

  categoryUuid: PropTypes.string,
  categoryApis: arrayOf(object),
  organizationsListResult: arrayOf(object),
  fetchOrganizationsFiltered: func,
  classes: PropTypes.object,
  currentTab: PropTypes.string,
  fetchCategoryApisAccess: PropTypes.func,
  isLoading: PropTypes.bool,
  label: string,
  isError: bool,
  pageErrors: arrayOf(shape({})),
};

TCApis.displayName = 'TCApis';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(TCApis);